import type { Ref, RefObject } from "react";

import { clsx } from "../../utils/clsx";
import type { ScrollSizes } from "./use-scroll-sizes";

interface ScrollAreaThumbProps {
  className?: string;
  isHorizontal?: boolean;
  passThrough?: boolean;
  sizes: ScrollSizes;
  onThumbPointerUp: () => void;
  onThumbPointerDown: (pointerPos: number) => void;
  onThumbPositionChange: () => void;
  ref?: Ref<HTMLDivElement | null>;
  viewportRef: RefObject<HTMLDivElement | null>;
}

export const ScrollAreaThumb = ({
  className,
  isHorizontal,
  passThrough,
  sizes,
  onThumbPointerUp,
  onThumbPointerDown,
  ref,
}: ScrollAreaThumbProps) => {
  const thumbSize = sizes ? getThumbSize(sizes) : 0;

  return (
    <div
      className={clsx("absolute bg-contrast-900", isHorizontal ? "h-full" : "w-full", passThrough && "pointer-events-none", className)}
      style={{ [isHorizontal ? "width" : "height"]: `${thumbSize}px` }}
      onPointerUp={onThumbPointerUp}
      onPointerDownCapture={(event) => {
        const thumb = event.target as HTMLElement;
        const thumbRect = thumb.getBoundingClientRect();
        const pos = isHorizontal ? event.clientX - thumbRect.left : event.clientY - thumbRect.top;

        onThumbPointerDown(pos);
      }}
      ref={ref}
    />
  );
};

export const getThumbSize = (sizes: ScrollSizes) => {
  const visibleContentRatio = sizes.contentSize === 0 ? 0 : sizes.viewportSize / sizes.contentSize;

  return Math.max(sizes.viewportSize * visibleContentRatio, 18);
};
